export default __webpack_public_path__ + "static/testimonialCompanyLogo3-7a5f6fac31ace757d4d0ff5c29e34d88.svg";